import { render, staticRenderFns } from "./ModalUpdate.vue?vue&type=template&id=74c15813&scoped=true"
import script from "./ModalUpdate.vue?vue&type=script&lang=js"
export * from "./ModalUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c15813",
  null
  
)

export default component.exports